module.exports = framework_dll_6f4c3abab814fd8f9432;